import React, { useState, useEffect } from 'react';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import myPDF from "./report1.pdf";
import fontTHSarabunNew from '../../../../THSarabunNew.ttf';
import fontkit from '@pdf-lib/fontkit';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
// import fs from 'fs';
import { formatDateTH, formatDateTHYYYY } from '../../../../common/DateUtils';
import dataProperties from '../../components/EmploymentPage/PersonProperties';

// from R1Frame.js

function R1v2() {
  const [pdfUrl, setPdfUrl] = useState('');
  const [param1, setParam1] = useState('');
  const [employee, setEmployee] = useState('');
  const [loading, setLoading] = useState(false);

  //รูปลายเซ็น
  const [sign, setSign] = useState('');
  const [signImg, setSignImg] = useState('');

  const { user: currentUser } = useSelector((state) => state.auth);

  const getEmployee = async (uid) => {
    console.log('--R1v2.js--getEmployee--1');
    setLoading(true);
    try {
      const { data } = await axios.get('/api/cis/employee/uid', {
        params: { id: uid },
      });

      console.log('--R1v2.js--getEmployee--2');
      console.log(data);

      getSignature(data?.emp?.idCard); //ดึงลายเซ็น
      setEmployee(data);

      // const {
      //   emp: { firstName: fname, lastName, presentAddress },
      //   edu: [{ durationOfCourse }],
      // } = data;

      // const [
      //   {
      //     emp: { firstName: fname, lastName, presentAddress },
      //   },
      // ] = data;
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getDataFromAPI = () => {
    // Sample API to fetch Data
    console.log('API called!!');
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setTimeout(() => {
          // updateForm();
          // setIsLoading(false);
          //delay 1200
          console.log(res);
        }, 400);
      });
  };

  var BASE64_MARKER = ';base64,';

  function convertDataURIToBinary(dataURI) {
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  //ลายเซ็น
  const getSignature = async (idCard) => {
    console.log('--R1v2.js--getSignature--1');
    try {
      const { data } = await axios.get(`/api/signupload/${idCard}`);
      console.log('--R1v2.js--getSignature--2', data);
      setSign(data?.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    if (!!sign) {
      const buffer = new Buffer.from(sign, 'base64');
      const dataImagePrefix = `data:image/png;base64,`;
      setSignImg(`${dataImagePrefix}${buffer.toString('base64')}`);
    }
  }, [sign]);

  useEffect(() => {
    if (!!signImg) {
      setEmployee({ ...employee, signImg: signImg });
    }
  }, [signImg]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('id');
    console.log('--R1v2.js--uid--', uid);
    getEmployee(uid);
    // getDataFromAPI();
  }, []);

  useEffect(() => {
    // const queryParams = new URLSearchParams(window.location.search);
    // const uid = queryParams.get('id');
    // console.log('--R1v2.js--uid--', uid);
    // getEmployee(uid);

    const loadPdf = async () => {
      const url = '/app/document1v3.pdf';
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer()
      );
      // const pdfDoc = await PDFDocument.load(myPDF);
      // PDFDocument.registerFontkit(fontkit);

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      // const fontData = await fs.readFile('../../../../THSarabunNew.ttf');
      // const myFont = await pdfDoc.embedFont(fontData, { subset: true });

      // const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
      // const fontBytes = await fetch(fontTHSarabunNew).then((res) => res.arrayBuffer());
      // const fontTH = await pdfDoc.embedFont(fontBytes);

      // const fontData = fs.readFileSync('../../../../THSarabunNew.ttf');
      // const fontTH = fontkit.create(fontBytes);

      const fontBytes = await fetch(fontTHSarabunNew).then((res) =>
        res.arrayBuffer()
      );
      const myFont = await pdfDoc.embedFont(fontBytes, { subset: true });

      console.log('----R1v2---loadPdf----', employee?.emp?.firstName);

      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();

      //ชื่อ
      if (employee?.emp?.firstName) {
        const title = employee.emp.title;
        let fName = employee.emp.firstName;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย ';
        if (title == 2) titleNm = 'นาง ';
        if (title == 3) titleNm = 'น.ส. ';
        // fName = titleNm + ' ' + fName;
        firstPage.drawText(`${fName}`, {
          x: 85,
          y: 575,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
          // rotate: degrees(-45),
        });
      }

      // const form = pdfDoc.getForm()
      // const exiaField = form.createCheckBox('gundam.exia')
      // exiaField.addToPage(firstPage, { x: 10, y: 10 })
      // exiaField.check()

      //นามสกุล
      firstPage.drawText(`${employee?.emp?.lastName}`, {
        x: 230,
        y: 575,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
        // rotate: degrees(-45),
      });

      // console.log('----R2v2---employee.fileBase64---', employee.fileBase64);
      // var pdfAsDataUri = 'data:application/pdf;base64,JVBERi0xLjUK...'; // shortened
      // var pdfAsDataUri = employee.fileBase64;
      // var pdfAsArray = convertDataURIToBinary(pdfAsDataUri);
      //รูปผู้สมัคร
      if (!!employee.fileBase64) {
        let checkErr = false; //check jpg, png
        try {
          // const image2 = await pdfDoc.embedJpg(`${employee.fileBase64}`);
          const image2 = await pdfDoc.embedJpg(employee.fileBase64);
          const jpgDims = image2.scale(0.3);
          firstPage.drawImage(image2, {
            x: 472,
            // y: 610,
            y: 792 - 176,
            width: 78,
            height: (jpgDims.height / jpgDims.width) * 78,
          });
        } catch (err) {
          //ถ้า error อาจจะเป็น png
          checkErr = true;
          console.log(err);
        }
        //ลองแบบ png จาก checkErr
        if (checkErr) {
          try {
            const image2 = await pdfDoc.embedPng(employee.fileBase64);
            const jpgDims = image2.scale(0.3);
            firstPage.drawImage(image2, {
              x: 472,
              y: 792 - 176,
              width: 78,
              height: (jpgDims.height / jpgDims.width) * 78,
            });
          } catch (err) {
            console.log(err);
          }
        }
      }

      //check ลูกจ้างทดลองงาน
      const checkMarkUrl = '/app/checkmark-png-25953.png';
      const checkMarkImageBytes = await fetch(checkMarkUrl).then((res) =>
        res.arrayBuffer()
      );
      const checkMarkImage = await pdfDoc.embedPng(checkMarkImageBytes);
      const pngDims = checkMarkImage.scale(0.02);
      firstPage.drawImage(checkMarkImage, {
        x: 180,
        y: 647,
        width: pngDims.width,
        height: pngDims.height,
      });

      //ENGNAME
      firstPage.drawText(`${employee?.emp?.engName?.toUpperCase()}`, {
        x: 360,
        y: 575,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
        // rotate: degrees(-45),
      });

      // console.log('----R2v2.js---width--height---', firstPage.getWidth(), firstPage.getHeight())

      //เลขที่ใบสมัคร,
      //gimp    471,64
      //pdf-lib 612,792
      //ใช้ GIMP import เลือกขนาดไฟล์ 612x792, ดูจาก firstPage.getWidth(), firstPage.getHeight(), เลือก px
      //gg: how to show x,y on pdf document
      //https://coderwall.com/p/3h8nog/view-real-time-pdf-coordinates
      //แกน x ใข้ได้เลย
      //แกน y จะสลับกัน ให้เอา firstPage.getHeight() ตั้ง (792)
      firstPage.drawText(`${employee?.emp?.applicantNo}`, {
        x: 480,
        y: 792 - 63,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
        // rotate: degrees(-45),
      });

      // firstPage.drawText(`${employee?.emp?.idCard}`, {
      //   x: 180,
      //   y: 600,
      //   size: 14,
      //   font: myFont,
      //   color: rgb(0, 0, 0.5),
      //   // rotate: degrees(-45),
      // });

      //ตำแหน่ง
      firstPage.drawText(
        `${employee?.jobData?.position} ระดับ ${employee?.jobData?.empLevel}`,
        {
          x: 282,
          y: 792 - 164,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
          // rotate: degrees(-45),
        }
      );

      //เลขบัตรประจำตัวประชาชน
      const idCardStr = String(employee?.emp?.idCard || '');
      const idCardArr = idCardStr.split('');
      const pos = [
        199, 217, 233, 250, 266, 284, 302, 318, 334, 351, 368, 385, 401,
      ];
      idCardArr.forEach((v, i) => {
        firstPage.drawText(`${v}`, {
          x: pos[i],
          y: 792 - 247,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      });

      const birthDtTH = formatDateTH(employee?.forReport?.birthdate);
      // console.log('----R2v2.js---thaiDate---', birthDtTH)

      //วันเกิด
      firstPage.drawText(`${birthDtTH}`, {
        x: 128,
        y: 792 - 272,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //น้ำหนัก
      firstPage.drawText(`${employee?.emp?.weight}`, {
        x: 227,
        y: 792 - 272,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //ส่วนสูง
      firstPage.drawText(`${employee?.emp?.height}`, {
        x: 358,
        y: 792 - 272,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //สัญชาติ
      firstPage.drawText(`${employee?.emp?.nationality || ''}`, {
        x: 484,
        y: 792 - 272,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      const marriageCode = employee?.emp?.marriageStatus;

      //ยังไม่ได้ใช้
      // const test = dataProperties.maritalStatusOptions.find((obj) => obj.value == marriageCode)
      // console.log('----R2v2.js---maritalStatusOptions---', test?.label)

      //สถานภาพ TEST
      // firstPage.drawText(`${marriageCode}`, {
      //   x: 160,
      //   y: 792 - 292,
      //   size: 14,
      //   font: myFont,
      //   color: rgb(0, 0, 0.5),
      // });

      //สถานภาพ
      let posM;
      if (marriageCode == '0') posM = 124;
      if (marriageCode == '1') posM = 175;
      if (marriageCode == '3') posM = 230;
      if (marriageCode == '2') posM = 284;
      firstPage.drawImage(checkMarkImage, {
        x: posM,
        y: 792 - 294,
        width: pngDims.width,
        height: pngDims.height,
      });

      //ภูมิลำเนาเดิมจังหวัด
      firstPage.drawText(`${employee?.emp?.homeProvinceName || ''}`, {
        x: 429,
        y: 792 - 292,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //ชื่อ-นามสกุล คู่สมรส
      firstPage.drawText(`${employee?.emp?.spouseName || ''}`, {
        x: 160,
        y: 792 - 312,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //สถานที่ทำงาน คู่สมรส
      const spLen = employee?.emp?.spouseOffice?.length;
      let fontSpSize = 14;
      if (spLen > 30) fontSpSize = 10;
      firstPage.drawText(`${employee?.emp?.spouseOffice || ''}`, {
        x: 160,
        y: 792 - 326,
        size: fontSpSize,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //จำนวนบุตร
      firstPage.drawText(`${employee?.emp?.numberOfChildren || ''}`, {
        x: 469,
        y: 792 - 312,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //โทรศัพท์ คู่สมรส
      firstPage.drawText(`${employee?.emp?.spousePhone || ''}`, {
        x: 469,
        y: 792 - 326,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //ประวัติการศึกษา

      if (!!employee.edu) {
        if (!!employee.edu[0]) {
          console.log(
            '----R2v2.js---employee?.edu---',
            employee.edu[0].degreeId
          );

          const posX = [135, 203, 284, 350, 400, 440, 475, 516];

          const graduateDateYYYY = formatDateTHYYYY(
            employee.edu[0].graduateDate
          );

          //ปวส.
          const posDiplomaData = [
            'ปวส.',
            employee.edu[0].instituteName,
            employee.edu[0].inOutCountry,
            employee.edu[0].privateOrGovernment,
            graduateDateYYYY,
            employee.edu[0]?.duration?.toString(),
            employee.edu[0]?.grade?.toString(),
            'ปวส.',
          ];

          //ป.ตรี
          const posBachelorData = [
            employee.edu[0].certificateName,
            employee.edu[0].instituteName,
            employee.edu[0].inOutCountry,
            employee.edu[0].privateOrGovernment,
            graduateDateYYYY,
            employee.edu[0]?.duration?.toString(),
            employee.edu[0]?.grade?.toString(),
            'ป.ตรี',
          ];

          //ป.โท
          const posMasterDegreeData = [
            employee.edu[0].certificateName,
            employee.edu[0].instituteName,
            employee.edu[0].inOutCountry,
            employee.edu[0].privateOrGovernment,
            graduateDateYYYY,
            employee.edu[0]?.duration?.toString(),
            employee.edu[0]?.grade?.toString(),
            'ป.โท',
          ];

          //ชื่อคุณวุฒิ

          const degreeId = employee.edu[0].degreeId;
          //ปวส.
          if (degreeId == 41) {
            //loop แต่ละคอลัมน์
            for (let i = 0; i < 8; i++) {
              const len = posDiplomaData[i].length;
              let pos = 491;
              if (len > 25) pos = 501;
              if (i == 3) {
                //รัฐบาล/เอกชน
                if (len > 10) pos = 501;
              }
              firstPage.drawText(posDiplomaData[i], {
                x: posX[i],
                y: 792 - pos,
                size: i != 1 ? 14 : 12, //สถานศึกษาใช้ font เล็กลง
                font: myFont,
                color: rgb(0, 0, 0.5),
              });
            }
          }
          //ปริญญาตรี
          if (degreeId == 31) {
            for (let i = 0; i < 8; i++) {
              const len = posBachelorData[i].length;
              let pos = 461;
              if (len > 25) pos = 470;
              if (i == 1) {
                //สถานศึกษา
                if (len > 15) pos = 470;
              }
              if (i == 3) {
                //รัฐบาล/เอกชน
                if (len > 10) pos = 470;
              }
              firstPage.drawText(posBachelorData[i], {
                x: posX[i],
                y: 792 - pos,
                //ถ้าเป็นช่องคุณวุฒิ และสถานศึกษา ใช้ font 12, else 14
                size: i != 0 && i != 1 ? 14 : 12,
                font: myFont,
                color: rgb(0, 0, 0.5),
                // maxWidth: 10,
              });
            }
          }
          //ปริญญาโท
          if (degreeId == 21) {
            for (let i = 0; i < 8; i++) {
              firstPage.drawText(posMasterDegreeData[i], {
                x: posX[i],
                y: 792 - 436,
                size: i != 1 ? 14 : 10,
                font: myFont,
                color: rgb(0, 0, 0.5),
              });
            }
          }
        }
      }

      //ภาษาต่างประเทศ
      //ภาษาอังกฤษ
      if (!!employee.skillLanguage) {
        const posLang1 = [136, 173, 207, 256];
        const lang1Speak = dataProperties.languageSkill.find(
          (obj) => obj.value == employee?.skillLanguage[0]?.speakingLevelId
        );
        const lang1Read = dataProperties.languageSkill.find(
          (obj) => obj.value == employee?.skillLanguage[0]?.readingLevelId
        );
        const lang1Write = dataProperties.languageSkill.find(
          (obj) => obj.value == employee?.skillLanguage[0]?.writingLevelId
        );
        // let langCert = employee?.skillLanguage[0]?.certificate;
        let langCert = employee?.emp?.englishLanguageCertificate;
        langCert = !!langCert ? langCert : ''; //check null
        // const langCert2 = !!langCert ? langCert : '';
        // console.log('----R2v2.js---employee?.skillLanguage?.speakingLevelId---', employee?.skillLanguage[0]?.speakingLevelId)
        // console.log('----R2v2.js---lang1Speak---', lang1Speak.label)
        const lang1Data = [
          lang1Speak.label,
          lang1Read.label,
          lang1Write.label,
          langCert,
        ];
        for (let i = 0; i < 4; i++) {
          firstPage.drawText(`${lang1Data[i]}`, {
            x: posLang1[i],
            y: 792 - 640,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });
        }

        //ภาษาที่สอง
        if (!!employee.skillLanguage[1]) {
          const posLang1 = [136, 173, 207, 256];
          const lang2Speak = dataProperties.languageSkill.find(
            (obj) => obj.value == employee?.skillLanguage[1]?.speakingLevelId
          );
          const lang2Read = dataProperties.languageSkill.find(
            (obj) => obj.value == employee?.skillLanguage[1]?.readingLevelId
          );
          const lang2Write = dataProperties.languageSkill.find(
            (obj) => obj.value == employee?.skillLanguage[1]?.writingLevelId
          );
          let lang2Cert = employee?.skillLanguage[1]?.certificate;
          lang2Cert = !!lang2Cert ? lang2Cert : ''; //check null
          // console.log('----R2v2.js---employee?.skillLanguage?.speakingLevelId---', employee?.skillLanguage[0]?.speakingLevelId)
          // console.log('----R2v2.js---lang1Speak---', lang1Speak.label)
          const lang2Data = [
            lang2Speak.label,
            lang2Read.label,
            lang2Write.label,
            lang2Cert,
          ];
          //loop แต่ละช่อง
          firstPage.drawText(`${employee?.skillLanguage[1]?.name}`, {
            x: 73,
            y: 792 - 674,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });
          for (let i = 0; i < 4; i++) {
            firstPage.drawText(`${lang2Data[i]}`, {
              x: posLang1[i],
              y: 792 - 669,
              size: 14,
              font: myFont,
              color: rgb(0, 0, 0.5),
            });
          }
        }
      }

      //สถานะทางทหาร
      const military = employee?.emp?.militaryStatusId;
      // console.log('----R2v2.js---military---', military)
      let posMili;
      if (military == 2) posMili = 622; //ยังไม่ได้เข้ารับการตรวจเลือกทหาร
      if (military == 1) posMili = 651; //เข้ารับราชการทหารแล้ว
      if (military == 3) posMili = 678; //ได้รับการยกเว้น (ไม่ใช่ผ่อนผัน) เนื่องจาก
      const test = [2, 1, 3];
      if (test.includes(military)) {
        firstPage.drawImage(checkMarkImage, {
          x: 353,
          y: 792 - posMili,
          width: pngDims.width,
          height: pngDims.height,
        });
        //ได้รับการยกเว้น (ไม่ใช่ผ่อนผัน) เนื่องจาก
        if (military == 3) {
          const mReason = employee?.emp?.militaryExceptReason;
          const len = mReason.length;
          let fontSize = 14;
          //ถ้ายาวมาก จะให้ font เล็กลง
          let moveX = 0;
          if (len > 60) {
            fontSize = 11;
            moveX = 5;
          }
          firstPage.drawText(`${mReason}`, {
            x: 380 - moveX,
            y: 792 - 690,
            size: fontSize,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });
        }
      }

      const secondPage = pages[1];
      //ประวัติการฝึกอบรม/ฝึกงาน
      try {
        let totalCompany = [];
        employee.trainingHistory.forEach((train) => {
          // console.log('----R2v2.js---totalCompany---', train.companyName);
          totalCompany.push(
            train.companyName +
              ' ' +
              ' ปี ' +
              formatDateTHYYYY(train.trainingYear)
          );
        });
        //array to string
        let totalCompanyStr = totalCompany.join();
        const comLen = totalCompanyStr.length;
        let fontComSize = 14;
        let posX = 80;
        let posY = 94;
        //ถ้ายาวมากกว่า 130 ตัวอักษรจะ substring และ font เล็กลง
        if (comLen > 130) {
          fontComSize = 10;
          posX = 237;
          posY = 74;
          // totalCompanyStr = totalCompanyStr.substring(0, 130) + '...';
        }
        // console.log('----R2v2.js---totalCompany---', totalCompany);
        secondPage.drawText(`${totalCompanyStr}`, {
          x: posX,
          y: 792 - posY,
          size: fontComSize,
          font: myFont,
          maxWidth: 330,
          lineHeight: 10,
          color: rgb(0, 0, 0.5),
        });
      } catch (err) {
        console.log(err);
      }

      //ความรู้ด้าน computer
      if (!!employee?.emp?.computerSkill) {
        const comSkillArr = employee.emp.computerSkill.split(',');

        let r1 = [];
        comSkillArr.forEach((x) => {
          const test = dataProperties.computerSkillOptions.find(
            (c) => c.id == x && c.id != '16'
          );
          r1.push(test);
        });

        //remove undefined
        const r2 = r1.filter((i) => i);

        //loop เอามาต่อกัน
        let comSkillStr = '';
        r2.forEach((v) => (comSkillStr += v.name + ', '));

        if (employee?.emp?.computerSkill?.includes('16'))
          comSkillStr += employee.emp?.otherComputerSkill;

        // console.log('----R2v2.js---comSkillStr---', comSkillStr);
        const comSkLen = comSkillStr.length;
        let fontComSkSize = 14;
        //ถ้ายาวมากกว่า 130 ตัวอักษรจะ substring และ font เล็กลง
        if (comSkLen > 130) {
          fontComSkSize = 10;
          // comSkillStr = comSkillStr.substring(0, 130) + '...'
        }
        secondPage.drawText(`${comSkillStr}`, {
          x: 75,
          y: 792 - 125,
          size: fontComSkSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ความรู้ความสามารถพิเศษอื่นๆ
      //wraptext ถ้ายาวเกิน, maxWidth ใช้ร่วมกับ lineHeight
      //https://stackoverflow.com/questions/64500297/pdf-lib-ensure-text-remains-on-page-using-wrapping-and-size-reduction
      if (!!employee?.emp?.otherSkillDetail) {
        const otherSkill = employee.emp.otherSkillDetail;
        let oths2 = otherSkill.replace(/\n/g, ',');
        const len = oths2.length;
        let fontSize = 14;
        let posX = 76;
        let posY = 158;
        //ถ้ายาวมากกว่า 130 ตัวอักษรจะ substring และ font เล็กลง
        if (len > 130) {
          fontSize = 10;
          posX = 195;
          posY = 144;
          // oths2 = oths2.substring(0, 160) + '...'
        }
        secondPage.drawText(`${oths2}`, {
          x: posX,
          y: 792 - posY,
          size: fontSize,
          font: myFont,
          maxWidth: 350,
          lineHeight: 10,
          color: rgb(0, 0, 0.5),
        });
      }

      //โรคประจำตัว
      if (!!employee?.emp?.medicalProblem) {
        const medical = employee.emp.medicalProblem;
        secondPage.drawText(`${medical}`, {
          x: 73,
          y: 792 - 191,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ประสบการณ์ทำงาน
      try {
        if (!!employee?.workHistory) {
          let cnt = 0;
          const posX = [67, 217, 390, 478];
          let posY = 248;
          employee.workHistory.forEach((work) => {
            //ต้องการแค่ 4 บริษัท
            if (cnt > 3) return;
            if (work.employer == null) return; //prevent null

            if (cnt == 0) posY = 248;
            if (cnt == 1) posY = 274;
            if (cnt == 2) posY = 298;
            if (cnt == 3) posY = 325;

            //ชื่อหน่วยงาน
            secondPage.drawText(`${work.employer}`, {
              x: posX[0],
              y: 792 - posY + 7,
              size: 10,
              font: myFont,
              color: rgb(0, 0, 0.5),
            });
            //ตำแหน่ง
            secondPage.drawText(
              `${
                work.careerCode == '00000098'
                  ? work.career + ' ' + work.careerOther
                  : work.career
              }`,
              {
                x: posX[1],
                y: 792 - posY - 2,
                size: 10,
                font: myFont,
                color: rgb(0, 0, 0.5),
              }
            );
            //ระยะเวลา
            const period = work.workPeriod;
            secondPage.drawText(`${period || ''}`, {
              x: posX[2],
              y: 792 - posY,
              size: 14,
              font: myFont,
              color: rgb(0, 0, 0.5),
            });
            //อัตราเงินเดือน
            const salaryStr = work.salaryRate;
            const salaryStr2 = !!salaryStr ? salaryStr : ''; //check null, undefined
            let salaryStr3 = salaryStr2;
            const salaryStr4 = Number(salaryStr2);
            if (!isNaN(salaryStr4)) {
              const salaryFormat = salaryStr4.toLocaleString('en-US'); //ใส่ comma
              salaryStr3 = salaryFormat == 0 ? '' : salaryFormat; //ถ้าเป็น 0 ให้เป็นค่าว่าง
            }
            secondPage.drawText(`${salaryStr3}`, {
              x: posX[3],
              y: 792 - posY,
              size: 14,
              font: myFont,
              color: rgb(0, 0, 0.5),
            });

            ++cnt;
          });
        }
      } catch (err) {
        console.log(err);
      }

      //ที่อยู่ปัจจุบันที่ติดต่อได้
      try {
        const pAddr1 = employee?.emp?.presentAddress;
        const pAddr2 = employee?.emp?.presentTambolName;
        const pAddr3 = employee?.emp?.presentDistrictName;
        const pAddr4 = employee?.emp?.presentProvinceName;
        const pAddr5 = employee?.emp?.presentPostalCode;
        let pAddr = '';
        pAddr += pAddr1 + ' ';

        //กทม.
        if (employee?.emp?.presentProvinceId == 1) {
          if (!!pAddr2) pAddr += ' แขวง ' + pAddr2;
          if (!!pAddr3) pAddr += ' เขต ' + pAddr3;
          if (!!pAddr4) pAddr += ' จ.' + pAddr4;
          if (!!pAddr5) pAddr += ' ' + pAddr5;
        } else {
          if (!!pAddr2) pAddr += ' ต.' + pAddr2;
          if (!!pAddr3) pAddr += ' อ.' + pAddr3;
          if (!!pAddr4) pAddr += ' จ.' + pAddr4;
          if (!!pAddr5) pAddr += ' ' + pAddr5;
        }
        const len = pAddr.length;
        let fontSize = 14;
        //ถ้ายาวมาก จะให้ font เล็กลง
        let moveY = 0;
        if (len > 60) {
          fontSize = 12;
          moveY = 5;
        }
        secondPage.drawText(`${pAddr}`, {
          x: 64,
          y: 792 - 358 + moveY,
          size: fontSize,
          font: myFont,
          maxWidth: 300,
          lineHeight: 10,
          color: rgb(0, 0, 0.5),
        });
      } catch (err) {
        console.log(err);
      }

      //โทรศัพท์
      if (!!employee?.emp?.mobileNo) {
        const mobile = employee.emp.mobileNo;
        secondPage.drawText(`${mobile}`, {
          x: 396,
          y: 792 - 342,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อีเมล์
      if (!!employee?.emp?.email) {
        const email = employee.emp.email;
        secondPage.drawText(`${email}`, {
          x: 396,
          y: 792 - 359,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //บุคคลที่สามารติดต่อได้กรณีเร่งด่วน
      if (!!employee?.emp?.emergencyFirstName) {
        const title = employee.emp.emergencyTitle;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย ';
        if (title == 2) titleNm = 'นาง ';
        if (title == 3) titleNm = 'น.ส. ';
        const firstName = employee.emp.emergencyFirstName;
        const lastName = employee.emp.emergencyLastName;
        const relate = employee.emp.emergencyRelationship;
        const address = employee.emp?.emergencyAddress || '';
        const phone = employee.emp.emergencyMobileNo;
        const emerName = titleNm + firstName + ' ' + lastName;

        //ชื่อ-สกุล
        secondPage.drawText(`${emerName}`, {
          x: 260,
          y: 792 - 376,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //ที่อยู่
        const len = address?.length;
        let fontSize = 14;
        //ถ้ายาวมาก จะให้ font เล็กลง
        let moveY = 0;
        if (len > 70) {
          fontSize = 10;
          moveY = 5;
        }
        secondPage.drawText(`${address}`, {
          x: 94,
          y: 792 - 397 + moveY,
          size: fontSize,
          font: myFont,
          maxWidth: 360,
          lineHeight: 10,
          color: rgb(0, 0, 0.5),
        });

        //เกี่ยวข้องเป็น
        secondPage.drawText(`${relate}`, {
          x: 465,
          y: 792 - 375,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //เกี่ยวข้องเป็น
        secondPage.drawText(`${phone}`, {
          x: 465,
          y: 792 - 396,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ปฏิบัติงานต่างจังหวัด
      if (!!employee?.emp?.workOnRemoteSite) {
        const canWork = employee.emp.workOnRemoteSite;
        let posX = 0;
        const posY = 421;
        if (canWork == 'Y') posX = 292;
        if (canWork == 'N') posX = 232;
        secondPage.drawImage(checkMarkImage, {
          x: posX,
          y: 792 - posY,
          width: pngDims.width,
          height: pngDims.height,
        });
      }

      //ปฏิบัติงานต่างจังหวัด เป็นครั้งคราว
      if (!!employee?.emp?.workOnRemoteSiteOccasion) {
        const canWork = employee.emp.workOnRemoteSiteOccasion;
        let posX = 0;
        const posY = 421;
        if (canWork == 'N') posX = 427;
        if (canWork == 'Y') posX = 483;
        secondPage.drawImage(checkMarkImage, {
          x: posX,
          y: 792 - posY,
          width: pngDims.width,
          height: pngDims.height,
        });
      }

      //ลายเซ็นผู้สมัคร
      if (!!employee?.signImg) {
        function calculateImageSize(pngDims) {
          let imgWidth, imgHeight;

          // ตรวจสอบว่า ถ้าขนาดความกว้างของรูปภาพมากกว่าความสูง
          if (pngDims.width > pngDims.height) {
            // กำหนดความสูงให้ไม่เกิน 20px และปรับขนาดความกว้างตามสัดส่วนเดิม
            imgHeight = 30;
            imgWidth = (pngDims.width * imgHeight) / pngDims.height;
          } else {
            // กำหนดความกว้างให้ไม่เกิน 100px และปรับขนาดความสูงตามสัดส่วนเดิม
            imgWidth = 100;
            imgHeight = (pngDims.height * imgWidth) / pngDims.width;

            if (imgHeight > 30) {
              imgHeight = 30;
              imgWidth = (pngDims.width * imgHeight) / pngDims.height;
            }
          }

          return { width: imgWidth, height: imgHeight };
        }

        // ฟังก์ชันสำหรับวาดรูปภาพบน PDF โดยคงสัดส่วนเดิมไว้เมื่อความกว้างเกิน space
        async function drawImageOnPdf(image, secondPage) {
          // ปรับขนาดรูปภาพ
          const pngDims = image.scale(0.3);
          let { width: imgW, height: imgH } = calculateImageSize(pngDims);

          // พิกัดที่ต้องการวาดรูปภาพบน PDF
          const startX = 325;
          const startY = 147;
          const space = 467 - startX;

          // ตรวจสอบว่าความกว้างของรูปภาพเกินพื้นที่หรือไม่
          if (imgW > space) {
            // ปรับความกว้างให้เท่ากับพื้นที่และปรับความสูงตามสัดส่วนเดิม
            imgW = space - 20;
            imgH = (pngDims.height * imgW) / pngDims.width;
          }

          const rest = space - imgW;
          const restHalf = Math.round(rest / 2);

          // วาดรูปภาพบนหน้า PDF
          secondPage.drawImage(image, {
            x: startX + restHalf,
            y: startY,
            width: imgW,
            height: imgH,
          });
        }

        try {
          const image = await pdfDoc.embedPng(employee.signImg);
          drawImageOnPdf(image, secondPage);
        } catch (err) {
          console.log('err signature img', err);
        }
      }

      // posY =
      // let posX
      // if (Y) posx =
      // if (N) posx =
      // workOnRemoteSiteOccasion: 'Y',
      // workOnRemoteSite: 'Y',

      //ลงชื่อ
      if (!!employee?.emp?.firstName) {
        const title = employee.emp.title;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย';
        if (title == 2) titleNm = 'นาง';
        if (title == 3) titleNm = 'นางสาว';
        const fName = employee.emp.firstName;
        const lName = employee.emp.lastName;
        const fullName = titleNm + fName + ' ' + lName;

        const start = 325;
        const end = 464;
        //จัดให้อยู่กึ่งกลาง

        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        secondPage.drawText(`${fullName}`, {
          x: finalX,
          y: 792 - 666,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //วันที่
      if (!!employee?.emp?.createdDate) {
        const createdDateTH = formatDateTH(employee?.emp?.createdDate);
        const createdDateSplit = createdDateTH.split(' ');
        const cDate = createdDateSplit[0].startsWith('0')
          ? createdDateSplit[0].substring(1)
          : createdDateSplit[0];
        const cMonth = createdDateSplit[1];
        const cYear = createdDateSplit[2];

        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const start = { date: 315, month: 367, year: 454 };
        const end = { date: 348, month: 440, year: 495 };
        const space = {
          date: end.date - start.date,
          month: end.month - start.month,
          year: end.year - start.year,
        };
        const dateLen = {
          date: cDate.length,
          month: cMonth.length,
          year: cYear.length,
        };
        const rest = {
          date: space.date,
          month: space.month - dateLen.month,
          year: space.year - dateLen.year,
        };
        const restHalf = {
          date: Math.round(rest.date / 2),
          month: Math.round(rest.month / 2),
          year: Math.round(rest.year / 2),
        };

        //วัน
        secondPage.drawText(`${cDate}`, {
          x: 312 + restHalf.date - dateLen.date,
          y: 105,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //เดือน
        secondPage.drawText(`${cMonth}`, {
          x: 365 + restHalf.month - dateLen.month,
          y: 105,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //ปี
        secondPage.drawText(`${cYear}`, {
          x: 450 + restHalf.year - dateLen.year,
          y: 105,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfBytes], { type: 'application/pdf' })
      );
      setPdfUrl(pdfUrl);

      // setPdfUrl("/app/document1.pdf");
      // setPdfUrl("https://pdf-lib.js.org/assets/with_update_sections.pdf");
    };
    loadPdf();

    // console.log('employee created date',formatDateTHYYYY(employee?.emp.createdDate))
  }, [employee]);

  // https://dev.to/collegewap/fix-react-hook-useeffect-is-called-conditionally-25m5

  if (!currentUser) {
    return <Navigate to="/app/login" />;
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      {pdfUrl && (
        <iframe src={pdfUrl} width="100%" height="900px" title="PDF Viewer" />
      )}
    </div>
  );
}

export default R1v2;
